export const enIN = {
  OTHER_PURPOSES_LABEL: 'Other Purposes',
  OTHER_PURPOSES_DESCRIPTION: 'Ungrouped purposes will appear under "Other Purposes"',
  FEEDBACK_ANSWER_PLACEHOLDER: 'Type your answer',
  FEEDBACK_FORM_TITLE_LABEL: 'Feedback',
  FEEDBACK_SELECT_REASON_LABEL: 'Select a reason',
  FEEDBACK_SUBMIT_LABEL: 'Submit',
  PRIVACY_CENTER_LABEL: 'Privacy Center',
  MANAGE_PRIVACY_SETTINGS_LABEL: 'Manage your privacy settings here',
  PREFERENCE_CENTER_LABEL: 'Preference Center',
  UPDATE_PREFERENCES_LABEL: 'Update Preferences',
  REQUEST_CENTERS_LABEL: 'Request Centers',
  CONSENT_PREFERENCES_LABEL: 'Consent Preferences',
  CONSENT_PREFERENCES_SUPPORTING_TEXT: 'Manage your consent preferences for the purposes of data collection and processing.',
  NOTIFICATION_SETTINGS_LABEL: 'End user Notifications',
  NOTIFICATION_SETTINGS_SUPPORTING_TEXT: 'Configure notification settings for different profiles and Channels',
  PROFILE_NAME_LABEL: 'Profile Name',
  PROFILE_DESCRIPTION_LABEL: 'Profile Description',
  VERSION_LABEL: 'Version',
  ACTIVE_CONSENTS_LABEL: 'Active Consents',
  CONSENTED_ON_LABEL: 'Consented On',
  ACTION_BY_LABEL: 'Action by',
  VIEW_MORE_DETAILS: 'View More Details',
  PURPOSE_GROUP_LABEL: 'Purpose Group',
  VIEW_HISTORY: 'View History',
  GRANTED_LABEL: 'Granted',
  REVOKED_LABEL: 'Revoked',
  INACTIVE_LABEL: 'Inactive',
  DOWNLOAD_LABEL: 'Download',
  DOWNLOAD_NOTICE_LABEL: 'Download Notice',
  SCROLL_TO_BOTTOM_LABEL: 'Scroll to bottom',
  DOWNLOAD_CONSENT_RECORD_LABEL: 'Download Consent Record',
  DOWNLOAD_ARTIFACT_LABEL: 'Download Consent Artifact',
  GRANT_CONSENT_LABEL: 'Grant Consent',
  REVOKE_CONSENT_LABEL: 'Revoke Consent',
  PURPOSE_REVOKE_MODAL_TITLE: 'Consent Revocation Warning',
  PURPOSE_REVOKE_MODAL_DESCRIPTION: 'You have not consented to all purposes. Here are the implications:',
  REVOKE_THIS_CONSENT: 'Revoke This Consent?',
  REVOKE_BUTTON: 'Revoke',
  GRANT_BUTTON: 'Grant',
  RAISE_REQUEST_LABEL: 'Raise Request',
  NEW_REQUEST_LABEL: 'New Request',
  REQUESTS_LABEL: 'Requests',
  REQUEST_TYPE: 'Request Type',
  REQUEST_ID_LABEL: 'Request ID',
  TYPE_LABEL: 'Type',
  STATUS_LABEL: 'Status',
  CREATED_ON_LABEL: 'Created On',
  LAST_UPDATED_LABEL: 'Last Updated',
  CREATED_LABEL: 'Created',
  UPDATED_LABEL: 'Updated',
  RECORD_DETAILS_LABEL: 'Record Details',
  COMMUNICATIONS_LABEL: 'Communications',
  VIEW_REQUEST_LABEL: 'View Request',
  VIEW_COMMUNICATIONS_LABEL: 'View Communications',
  REQUEST_CENTER: 'Request Center',
  ACCEPT_ALL_LABEL: 'Accept All',
  ACCEPT_SELECTED_LABEL: 'Accept Selected',
  ACCEPT_NONE_LABEL: 'Accept None',
  CANCEL_LABEL: 'Cancel',
  SAVE_PREFERENCES_LABEL: 'Save Preferences',
  OK_LABEL: 'OK',
  BACK_LABEL: 'Go Back',
  SELECT_LABEL: 'Select',
  ENTER_LABEL: 'Enter',
  SWITCH_USER: 'Switch User',
  SECURED_BY_LABEL: 'Secured By',
  OR_LABEL: 'OR',
  EMAIL_OTP: 'Email OTP',
  GET_EMAIL_OTP: 'Get Email OTP',
  AUTHENTICATE_WITH_OTP: 'Authenticate with OTP',
  EMAIL_OR_PHONE_LABEL: 'Email or Phone Number',
  OTP_LABEL: 'OTP',
  GET_OTP: 'Get OTP',
  VERIFY_OTP: 'Verify OTP',
  RESEND_OTP: 'Resend OTP',
  RESEND_OTP_TIMER: 'Resend OTP in {timeLeft} seconds',
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
  EMAIL_NOTIFICATIONS_LABEL: 'Email Notifications',
  SMS_NOTIFICATIONS_LABEL: 'SMS Notifications',
  PURPOSE_COLUMN: 'Purpose',
  UPDATED_ON: 'Updated On',
  NO_LOGS_AVAILABLE: 'No Logs Available',
  UPLOAD_PROOF_LABEL: 'Upload proof',
  UPLOAD_FILE_HERE_LABEL: 'Upload file here',
  DRAG_DROP_FILES_LABEL: 'or drag and drop files',
  PERMITTED_FILE_FORMAT_LABEL: 'Permitted file format: PNG, JPEG and PDF',
  UPLOADING_LABEL: 'Uploading...',
  UPLOAD_LABEL: 'Upload',
  ATTACH_FILE_LABEL: 'Attach File',
  ATTACH_FILE_TOOLTIP_LABEL: 'You can upload PDFs, Word documents (DOC/DOCX), spreadsheets (XLS/XLSX/CSV), and images (JPG/PNG), maximum file size: 10 MB',
  RESPONSES_FOR_THIS_QUESTION_LABEL: 'Responses for this question',
  NO_RESPONSES_ADDED_YET_LABEL: 'No responses added yet',
  ADD_A_RESPONSE_LABEL: 'Add a response...',
  ADD_RESPONSE_LABEL: 'Add Response',
  SOMETHING_WENT_WRONG_LABEL: 'Something went wrong!',
  FILE_UPLOAD_ERROR_TITLE_LABEL: 'File Upload Error',
  UPLOAD_FAILED_ERROR_LABEL: 'Upload failed',
  FILE_TYPE_NOT_SUPPORTED_ERROR_LABEL: 'File type not supported. Please upload PDF, DOC/DOCX, XLS/XLSX/CSV, JPG, JPEG, or PNG files.',
  FILE_SIZE_EXCEEDS_LIMIT_ERROR_LABEL: 'File size exceeds 10MB limit.',
  AUTH_TOOLTIP: 'Enabled by default if authentication is enabled',
  FILE_UPLOAD_STATUS_VALIDATING_LABEL: 'Validating...',
  FILE_UPLOAD_STATUS_PREPARING_LABEL: 'Preparing...',
  FILE_UPLOAD_STATUS_COMPLETE_LABEL: 'Complete',
  FILE_UPLOAD_STATUS_FAILED_LABEL: 'Failed',
  FILE_UPLOAD_STATUS_CANCELLED_LABEL: 'Cancelled',
  FILE_UPLOAD_STATUS_READY_LABEL: 'Ready',
  TOTAL_LABEL: 'Total',
  UNKNOWN_FILE_LABEL: 'Unknown file',
  ACTIVE_CONSENTS_COUNT: '{totalActive} Active',
  CONSENTS_NAV_LABEL: 'Consents',
  REQUESTS_NAV_LABEL: 'Requests',
  ALERTS_NAV_LABEL: 'Alerts',
  ACCOUNT_NAV_LABEL: 'Account',
  CONSENT_DETAILS_LABEL: 'Consent Details',
  DATA_CATEGORY_LABEL: 'Data Category',
  DATA_CATEGORIES_LABEL: 'Data Categories',
  DATA_CATEGORY_COUNT_ONE: '{count} Data Category',
  DATA_CATEGORIES_COUNT: '{count} Data Categories',
  VIEW_ALL_PURPOSES: 'View all purposes',
  SELECT_ALL_LABEL: 'Select all',
  UNSELECT_ALL_LABEL: 'Unselect all',
  CONSENT_STATUS_LABEL: 'Consent Status',
  VALID_TILL_LABEL: 'Valid Till',
  COMMUNICATION_CHANNELS_LABEL: 'Communication Channels',
  OPTED_COMMUNICATION_CHANNELS_LABEL: 'Opted Communication Channels',
  OPTED_COMMUNICATION_CHANNELS_HELP_TEXT: 'Channels you have opted in to receive communications',
  HISTORY_LABEL: 'History',
  NO_HISTORY_LABEL: 'No history',
  PURPOSES_LABEL: 'Purposes',
  ACTION_LABEL: 'Action',
  CONSENTS_LABEL: 'Consents:',
  ACCOUNT_LABEL: 'Account',
  CHANGE_PROFILE_LABEL: 'Change Profile',
  LOGOUT_LABEL: 'Logout',
  SELECT_YOUR_PROFILE_LABEL: 'Select Your Profile',
  CHOOSE_YOUR_PROFILE_TO_CONTINUE_LABEL: 'Choose your profile to continue',
  SELECT_YOUR_USER_ACCOUNT_LABEL: 'Select Your User Account',
  MULTIPLE_USERS_FOUND_LABEL: 'Multiple user accounts are associated with this email/mobile number. Please select the account you want to continue with.',
  MORE_COUNT_LABEL: '+{count} more',
  NO_USER_FOUND_LABEL: "We couldn't find a user with the provided details.",
  NO_RESULTS_FOUND_LABEL: 'No results found',
  NO_RESULTS_FOUND_DESC_LABEL: "Try adjusting your search or filter to find what you're looking for.",
  ACCEPT_SELECTED_DISABLED_TOOLTIP: 'Please select all mandatory purposes',
  ACTIVE_CONSENTS: '${totalActive} Active',
  ADD_RESPONSE_CARD_LABEL: 'Add Response',
  ASSESSMENT_DESCRIPTION_LABEL: 'This assessment response questionnaire consists of questions related to {assessmentName}.',
  ASSESSMENT_LABEL: 'Assessment',
  ASSESSMENT_SUBMITTED_SUCCESSFULLY_LABEL: 'Assessment Submitted Successfully!',
  AT_LEAST_ONE_QUESTION_REQUIRED_LABEL: 'Please answer at least one question before submitting.',
  CIRCULAR_DEPENDENCY_DETECTED_LABEL: 'Circular dependency detected for question {questionId}',
  COMBINED_FILE_SIZE_ERROR_LABEL: 'Combined file size ({combinedSizeMB}MB) exceeds {maxSizeMB}MB limit for this question.',
  COOKIE_CATEGORY_LABEL: '{category} Cookie',
  COOKIE_DESCRIPTION_LABEL: 'Description',
  COOKIE_LABEL: 'Cookie',
  COOKIE_LOCALE_SELECTOR_ARIA_LABEL: 'Select language',
  COOKIE_NOTICE_CLOSE_ARIA_LABEL: 'Close',
  COOKIE_NOTICE_SR_ANNOUNCEMENT: 'Cookie consent notice. Review your cookie options below.',
  COOKIE_NOTICE_TITLE: 'Cookie Notice',
  COOKIE_PARTY_TYPE_LABEL: 'Party Type',
  COOKIE_PREFERENCE_CLOSE_ARIA_LABEL: 'Close',
  COOKIE_PREFERENCE_SR_ANNOUNCEMENT: 'Cookie preference center is open. Review and save your cookie choices.',
  COOKIE_SOURCE_LABEL: 'Source',
  CUSTOMISE_CONSENT_PREFERENCES_TITLE: 'Customise Consent Preferences',
  DAYS_AGO_LABEL: '2 days ago',
  DRAFT_SAVED_SUCCESSFULLY_LABEL: 'Draft saved successfully!',
  DRAFT_URL_NOT_FOUND_ERROR_LABEL: 'Draft save URL not found in assessment data',
  DUE_DATE_LABEL: 'Due Date',
  ENTER_A_NUMBER_LABEL: 'Enter a number',
  ENTER_RESPONSE_LABEL: 'Enter Response',
  ENTER_YOUR_ANSWER_LABEL: 'Enter your answer',
  ERROR_FALLBACK_DESCRIPTION_LABEL: "We couldn't load this page. Please try again, or head back to a safe place.",
  ERROR_OCCURRED_LABEL: 'Error Occurred',
  FAILED_TO_FETCH_QUESTION_LABEL: 'Failed to fetch question {questionId}:',
  FAILED_TO_SAVE_DRAFT_LABEL: 'Failed to save draft',
  FAILED_TO_SUBMIT_ASSESSMENT_LABEL: 'Failed to submit assessment',
  FILENAME_REQUIRED_ERROR_LABEL: 'fileName is required and must be a string',
  FILE_IS_EMPTY_ERROR_LABEL: 'File is empty.',
  FILE_UPLOAD_STATUS_UPLOADING_LABEL: 'Uploading...',
  GO_TO_HOME_LABEL: 'Go to Home',
  LIMIT_REACHED_LABEL: '(limit reached)',
  LOADING_NEXT_QUESTION_LABEL: 'Loading next question...',
  MANDATORY_FILE_NOT_UPLOADED_LABEL: 'Please upload the required file for question: {questionName}',
  MANDATORY_PROOF_NOT_UPLOADED_LABEL: 'Please upload the required proof for question: {questionName}',
  MANDATORY_PURPOSES_VALIDATION_MESSAGE: 'Purposes marked with (*) are mandatory',
  READ_MORE_LABEL: 'Read more',
  READ_LESS_LABEL: 'Read less',
  CLOSE_LABEL: 'Close',
  MANDATORY_QUESTION_UNANSWERED_LABEL: 'Please answer the question: {questionName}',
  MAXIMUM_NESTING_DEPTH_REACHED_LABEL: 'Maximum nesting depth reached for question {questionId}',
  NA_LABEL: 'N/A',
  NEARING_LIMIT_LABEL: '(nearing limit)',
  NOTIFICATION_SETTINGS_UPDATED_LABEL: 'Notification settings updated successfully',
  NO_LABEL: 'No',
  NO_NOTIFICATION_SETTINGS_LABEL: 'No notification settings found',
  NO_REQUESTS_FOUND_LABEL: 'No requests found',
  NO_RESPONSES_HAVE_BEEN_ADDED_LABEL: 'No responses have been added to this question',
  OTHER_OPTION_PLACEHOLDER: 'Please specify',
  OTHER_RESPONSE_REQUIRED_MESSAGE: 'Please specify your response.',
  PLEASE_COMPLETE_MANDATORY_QUESTIONS_LABEL: 'Please complete the following mandatory questions:',
  PLEASE_TRY_AGAIN_LABEL: 'Please try again.',
  PRE_TICK_MANDATORY_CHECKBOX_DESCRIPTION: 'Mandatory purposes are pre-selected for the user',
  PURPOSE_LABEL: 'Purpose',
  QUESTION_DESCRIPTION_LABEL: 'Conversation with reviewer for this question',
  REMOVE_BUTTON_LABEL: '×',
  REQUEST_INFORMATION_LABEL: 'Request Information',
  REQUEST_RAISED_SUCCESS_LABEL: 'Request raised successfully',
  REQUIRED_ASTERISK_LABEL: '*',
  REQUIRED_FIELD_INDICATOR_LABEL: '*',
  RESPOND_LABEL: 'Respond',
  RESPONSES_LABEL: 'Responses',
  RESPONSE_SUBMITTED_SUCCESS_MESSAGE_LABEL: 'Your response has been submitted successfully. Thank you for completing the assessment.',
  SAVE_AS_DRAFT_LABEL: 'Save as Draft',
  SAVING_DRAFT_LABEL: 'Saving...',
  SELECT_PURPOSE_LABEL: 'Select purpose',
  SENDER_LABEL: 'Sender',
  SUBMISSION_FAILED_LABEL: 'Submission Failed',
  SUBMISSION_URL_NOT_FOUND_ERROR_LABEL: 'Submission URL not found in assessment data',
  SUBMITTING_LABEL: 'Submitting...',
  SUBMIT_RESPONSE_LABEL: 'Submit Response',
  TIMESTAMPS_LABEL: 'Timestamps',
  TO_LABEL: 'to',
  TRY_AGAIN_LABEL: 'Try Again',
  UNABLE_TO_LOAD_ASSESSMENT_LABEL: 'Unable to load assessment details: {errorMessage}',
  UNEXPECTED_ERROR_OCCURRED_MESSAGE_LABEL: 'An unexpected error occurred while submitting your assessment. Please try again.',
  UPLOAD_PROOF_BUTTON_LABEL: 'Upload Proof',
  USER_LABEL: 'User',
  USER_NAME_LABEL: 'User Name',
  YES_LABEL: 'Yes',
  YOUR_NAME_LABEL: 'Your_Name',
};
